// DS1.7.22
import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import Flex from '@wix/da-ds/pkg/Flex/Flex';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { URLS } from '@wix/da-url';
import { getCurrentUserHasCore } from '../../publicSession/selectors';
import s from './CoreExclusiveFeature.scss';
const CoreExclusiveFeature = ({ className, withoutBuyCTA, biData })=>{
    const { t } = useTranslation();
    const hasCore = useSelector(getCurrentUserHasCore);
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, hasCore || withoutBuyCTA ? /*#__PURE__*/ React.createElement(Flex, {
        gap: 4,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(CoreSymbol, {
        size: IconSize.SMALLER
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['core-exclusive']
    }, t('common.coreExclusive'))) : /*#__PURE__*/ React.createElement(Flex, {
        gap: 8,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['core-exclusive']
    }, t('common.coreExclusive')), /*#__PURE__*/ React.createElement(Flex, {
        gap: 4,
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(CoreSymbol, {
        size: IconSize.SMALLER
    }), /*#__PURE__*/ React.createElement(BiLink, {
        className: s['cta'],
        href: URLS.CORE_MEMBERSHIP,
        biData: biData
    }, t('common.upgradeToCoreCTA')))));
};
CoreExclusiveFeature.displayName = 'CoreExclusiveFeature';
export default CoreExclusiveFeature;

//# sourceMappingURL=CoreExclusiveFeature.js.map